import React, {Component} from 'react'
import {Button, Header, Icon, Modal, Popup, Table} from 'semantic-ui-react';
import _ from 'lodash'
import NotesModal from "../Schedule/addNotesModal";
import {deleteNotes, publishNotes} from "../../redux/modules/schedule";
import {connect} from "react-redux";
import {paySentWarning} from "../../utils/paySentWarning";

class FinancialNotesModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            notesModal : false,
            financialNotes: this.props.financialNotes,
            order: true,
            column: null
        }
    }


    handleEditNote = (financialNote) => {
        if (financialNote && financialNote.id) {
            this.setState({
                notesForm: {
                    id: financialNote.id,
                    notesType: financialNote.notesType,
                    title: financialNote.title,
                    desc: financialNote.desc,
                    financialNotes: financialNote.financialNotes,
                    practice: financialNote.practice,
                    date: financialNote.date,
                    dentists: financialNote.dentistId && financialNote.dentistId.toString(),
                    dentistId: financialNote.dentistId,
                    isTaxable: financialNote.isTaxable,
                    frequency: financialNote.frequency,
                    category: financialNote.category,
                    sageAccount: financialNote.sageAccount,
                    bcare: financialNote.bcare,
                    practiceId: financialNote.practiceId,
                    receipts : [],
                    documentation : financialNote.documentation,
                }
            })
        }
        this.setState({ notesModal: true });
    }

    hideNotesModal = () => {
        this.setState({ notesForm: {} });
        this.setState({ notesModal: false });
    };

    onClickPublishNotes = (notes) => {
        const { dispatch } = this.props;
        if (notes.title && notes.notesType && notes.date) {
            dispatch(publishNotes(notes))
                .then(res => {
                    if (res) {
                        alert('Notes added successfully.' + paySentWarning(res));
                    } else {
                        alert('Notes could not add.');
                    }
                })
                .catch(err => {
                    alert(err);
                });
            this.hideNotesModal();
        } else {
            alert('Please select date, Notes Type and Practices.');
        }
    };

    deleteNotesHandle = (noteId) => {
        const { dispatch } = this.props;
        let obj = {
            id: noteId,
        };
        dispatch(deleteNotes(obj)).then(data => {
            this.handleDataRefresh();
        });
        this.hideNotesModal();
    }

    handleSort = clickedColumn => () => {
        const {column, financialNotes, order} = this.state

        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                financialNotes: _.sortBy(financialNotes, [clickedColumn]),
                order: true,
            })

            return
        }

        this.setState({
            financialNotes: financialNotes.reverse(),
            order: !order
        })
    }

    getFinancialNotesTable = () => {
        let {financialNotes, column, order} = this.state;
        
        const direction = order ? 'down' : 'up';
        return <Table selectable fixed compact className="table">
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell width={1} className={`cursorPointer ${column === 'dateString' ? 'active': ''}`} onClick={this.handleSort('dateString')}>
                        Action
                    </Table.HeaderCell>
                    <Table.HeaderCell width={1} className={`cursorPointer ${column === 'dateString' ? 'active': ''}`} onClick={this.handleSort('dateString')}>
                        Date <i className={`sort amount ${direction} icon ml-05`}></i>
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing className={`cursorPointer ${column === 'title' ? 'active': ''}`} onClick={this.handleSort('title')}>
                        Title <i className={`sort amount ${direction} icon ml-05`}></i>
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing>
                        Provider
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing className={`cursorPointer ${column === 'practice' ? 'active': ''}`} onClick={this.handleSort('practice')}>
                        Practice <i className={`sort amount ${direction} icon ml-05`}></i>
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing className={`cursorPointer ${column === 'category' ? 'active': ''}`} onClick={this.handleSort('category')}>
                        Category <i className={`sort amount ${direction} icon ml-05`}></i>
                    </Table.HeaderCell>
                    <Table.HeaderCell width={1}>
                        Description
                    </Table.HeaderCell>
                    <Table.HeaderCell collapsing className={`cursorPointer ${column === 'frequency' ? 'active': ''}`} onClick={this.handleSort('frequency')}>
                        Frequency <i className={`sort amount ${direction} icon ml-05`}></i>
                    </Table.HeaderCell>
                    <Table.HeaderCell width={1} className={`cursorPointer ${column === 'isTaxable' ? 'active': ''}`} onClick={this.handleSort('isTaxable')}>
                        Taxable <i className={`sort amount ${direction} icon ml-05`}></i>
                    </Table.HeaderCell>
                    <Table.HeaderCell width={1} className={`cursorPointer ${column === 'sageAccount' ? 'active': ''}`} onClick={this.handleSort('sageAccount')}>
                        Account
                        <i className={`sort amount ${direction} icon ml-05`}></i>
                    </Table.HeaderCell>
                    <Table.HeaderCell width={1} collapsing className={`cursorPointer ${column === 'financialNotes' ? 'active': ''}`} onClick={this.handleSort('financialNotes')}>
                        Amount <i className={`sort amount ${direction} icon ml-05`}></i>
                    </Table.HeaderCell>
                    <Table.HeaderCell width={1} className={`cursorPointer ${column === 'bcare' ? 'active': ''}`} onClick={this.handleSort('bcare')}>
                        B.Care <i className={`sort amount ${direction} icon ml-05`}></i>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {financialNotes && financialNotes.map((financialNote) => {
                    return (
                        <Table.Row>
                            <Table.Cell><Button onClick={() => this.handleEditNote(financialNote)}>Edit</Button></Table.Cell>
                            <Table.Cell>{financialNote.dateString}</Table.Cell>
                            <Table.Cell>{financialNote.title}</Table.Cell>
                            <Table.Cell>{financialNote.dentist}</Table.Cell>
                            <Table.Cell>{financialNote.practice}</Table.Cell>
                            <Table.Cell>{financialNote.category}</Table.Cell>
                            <Table.Cell  style={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            }}>
                                <Popup content={financialNote.desc} trigger={<span>{financialNote.desc}</span>}/>
                            </Table.Cell>
                            <Table.Cell>{financialNote.frequency}</Table.Cell>
                            <Table.Cell>
                                <Icon name={financialNote.isTaxable ? 'check circle' : 'cancel'}
                                      color={financialNote.isTaxable ? 'green' : 'red'}/>
                            </Table.Cell>
                            <Table.Cell>{financialNote.sageAccount}</Table.Cell>
                            <Table.Cell>{financialNote.financialNotes}</Table.Cell>
                            <Table.Cell>{financialNote.bcare}</Table.Cell>
                        </Table.Row>
                    )
                })}

                {
                    financialNotes.length === 0 && <Table.Row>
                        <Table.Cell colSpan={10}>No Financial Notes</Table.Cell>
                    </Table.Row>
                }
            </Table.Body>
        </Table>
    }

    render() {
        const table = this.state.open ? this.getFinancialNotesTable() : <span/>;
        const {financialNotes} = this.props;
        const { notesModal, notesForm } = this.state;
        return (
            <>
                {notesModal &&
                    <NotesModal
                        hideNotesModal={this.hideNotesModal}
                        onClickPublishNotes={this.onClickPublishNotes}
                        deleteNotesHandle={this.deleteNotesHandle}
                        notesForm={notesForm}
                    />
                }
                <Modal
            onClose={() => this.setState({open: false, financialNotes: []})}
            onOpen={() => this.setState({open: true, financialNotes})}
            open={this.state.open}
            size='fullscreen'
            trigger={this.props.trigger}
        >
            <Icon
                name="close"
                className="cursorPointer"
                style={{ marginLeft: 'auto', cursor: 'pointer' }}
                onClick={() => this.setState({open: false, financialNotes: []})}
            />
            <Header>
                <Icon name='sticky note outline'/> Financial Notes: <b>{this.props.financialNoteTotal}</b>
            </Header>
            <Modal.Content>
                {table}
            </Modal.Content>
        </Modal></>
        )
    }
}
export default connect(state => ({

}))(FinancialNotesModal);